module.exports = __webpack_public_path__ + "static/media/C20-0696_250MamaSmile_Mobile_767x845.b2597c2d.jpg";